import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  plans: [],

  userPlan: {},

  billingUser: false,

  exceedQuota: {}
};

export const plan = createSlice({
  name: 'plan',
  initialState,
  reducers: {
    updateUserExceeded: (state, action) => {
      state.exceedQuota.userExceeded = action.payload;
    },
    updateCourseExceeded: (state, action) => {
      state.exceedQuota.courseExceeded = action.payload.courseExceeded;
    },
    updateTrackExceeded: (state, action) => {
      state.exceedQuota.trackExceeded = action.payload;
    },
    updateExceedQuota: (state, action) => {
      state.exceedQuota = action.payload;
    },
    updateBillingUser: (state, action) => {
      state.billingUser = action.payload.billingUser;
    },
    updateUserPlan: (state, action) => {
      state.userPlan = action.payload.userPlan;
    },
    updateAuPlans: (state, action) => {
      state.plans = action.payload.plans;
    }
  }
});

export const {
  updateUserExceeded,
  updateCourseExceeded,
  updateTrackExceeded,
  updateExceedQuota,
  updateBillingUser,
  updateUserPlan,
  updateAuPlans
} = plan.actions;

export default plan.reducer;
